export default __webpack_public_path__ + "/dist/images/print_img.2c3f2e83362c40eb8bda88ebab1f9c9b.svg";